var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pill-container"},[_c('span',_vm._b({staticClass:"statusicon",style:({ background: _vm.color, width: (_vm.size + "px"), height: (_vm.size + "px") })},'span',_vm.$attrs,false)),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }